'use client'
import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { campaignType } from '@/lib/campaign'
import { itemImageType } from '@/lib/item/server'
import { useEffect, useState } from 'react'
import { LikeButton } from '../parts/buttons/likeButton'

type CarouselImageProps = {
  images: itemImageType[]
  item_id: number
  service_id: string
  liked: boolean
  like_count: number
  one_day_sale?: boolean
  campaigns: campaignType[]
  name: string
}

export const ItemImageCarousel: React.FC<CarouselImageProps> = ({
  images,
  item_id,
  service_id,
  liked,
  like_count,
  one_day_sale,
  campaigns,
  name,
}) => {
  const [api, setApi] = useState<CarouselApi>()
  const [current, setCurrent] = useState(0)
  const [, setCount] = useState(0)
  useEffect(() => {
    if (!api) {
      return
    }
    setCount(api.scrollSnapList().length)
    setCurrent(api.selectedScrollSnap() + 1)
    api.on('select', () => {
      setCurrent(api.selectedScrollSnap() + 1)
    })
  }, [api])
  // 今日の日付を取得
  const date = new Date()
  const validCampaigns = campaigns.filter(
    (v) => new Date(v.deadline) > date && v.is_valid,
  )
  return (
    <Carousel
      className="w-full"
      setApi={setApi}
      opts={{
        loop: true,
      }}
    >
      <CarouselContent>
        {images.map((v, index) => (
          <CarouselItem key={index}>
            <img
              src={v.image_url}
              alt={`メイン画像:${index}枚目:${name}`}
              width={500}
              height={380}
              style={{
                height: '380px',
                objectFit: 'contain',
                verticalAlign: 'center',
              }}
              className="mx-auto"
            />
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious
        style={{
          left: 0,
          background: 'rgba(0,0,0,0.3)',
          border: 'none',
          color: '#fff',
        }}
      />
      <CarouselNext
        style={{
          right: 0,
          background: 'rgba(0,0,0,0.3)',
          border: 'none',
          color: '#fff',
        }}
      />
      <div className="flex overflow-x-auto">
        {images.map((v, index) => (
          <img
            key={index}
            src={v.image_url}
            alt={`サムネイル:${index}枚目:${name}`}
            width={70}
            height={70}
            onClick={() => {
              api?.scrollTo(index)
            }}
            style={{
              opacity: current === index + 1 ? 1 : 0.2,
              objectFit: 'cover',
              verticalAlign: 'middle',
              height: '80px',
              width: '80px',
            }}
          />
        ))}
      </div>
      <LikeButton
        service_id={service_id}
        item_id={item_id}
        liked={liked}
        count={like_count}
      />
      {one_day_sale && (
        <div className="one-day-sale-flag main-color absolute bottom-24 left-0 py-2 text-white px-4">
          <span>
            {date.getMonth() + 1}月{date.getDate()}日 23:59まで10%OFF
          </span>
        </div>
      )}
      {validCampaigns.length > 0 && (
        <div className="campaign-flag main-color absolute bottom-24 left-0 py-2 text-white px-4">
          <span>
            {campaigns[0].deadline.slice(0, 10).replaceAll('-', '/')} 23:59まで
            {campaigns[0].discount_rate}
            %OFF
          </span>
        </div>
      )}
    </Carousel>
  )
}
